/**
 * Event Filter - AJAX-based search and category filtering with URL parameters
 */

document.addEventListener('DOMContentLoaded', function() {
  const filterBar = document.querySelector('.c-card-grid__filter-bar');
  
  if (!filterBar) return;
  
  const filterTabs = filterBar.querySelectorAll('.c-card-grid__filter-tab');
  const searchInput = filterBar.querySelector('.c-card-grid__search-input');
  const gridContainer = document.querySelector('.c-card-grid__container');
  const loadingIndicator = document.querySelector('.c-card-grid__loading');
  
  let searchTimeout = null;
  let currentPage = 2; // Start at 2 since page 1 is already loaded on initial render
  let isLoading = false;
  let hasMore = true;
  
  // Get initial category from URL or active tab
  function getInitialCategory() {
    const urlParams = new URLSearchParams(window.location.search);
    const categoryParam = urlParams.get('category');
    
    if (categoryParam) {
      return categoryParam;
    }
    
    // Find active tab
    const activeTab = filterBar.querySelector('.c-card-grid__filter-tab.active');
    return activeTab ? activeTab.dataset.category : 'all';
  }
  
  let currentCategory = getInitialCategory();
  
  // Update URL without page reload
  function updateURL(category) {
    const url = new URL(window.location);
    
    if (category === 'all') {
      url.searchParams.delete('category');
    } else {
      url.searchParams.set('category', category);
    }
    
    window.history.pushState({}, '', url);
  }
  
  // Handle category tab clicks
  filterTabs.forEach(tab => {
    tab.addEventListener('click', function() {
      // Update active state
      filterTabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      
      // Get category and filter
      currentCategory = this.dataset.category;
      
      // Update URL
      updateURL(currentCategory);
      
      // Update page header
      updatePageHeader(currentCategory);
      
      // Reset pagination and filter events
      currentPage = 1;
      hasMore = true;
      filterEvents(true); // true = replace content
    });
  });
  
  // Update page header with category info
  function updatePageHeader(category) {
    if (category === 'all') {
      // Reload to show default header
      location.reload();
      return;
    }
    
    // Make AJAX request to get category info
    fetch(ajaxurl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        action: 'get_category_header',
        category: category
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        const pageHeader = document.querySelector('.c-page-header');
        if (pageHeader) {
          const title = pageHeader.querySelector('.c-page-header__title');
          const bgElement = pageHeader.querySelector('.c-page-header__bg');
          
          // Add fade out class
          if (title) title.classList.add('is-changing');
          if (bgElement) bgElement.classList.add('is-changing');
          
          // Wait for fade out, then update content
          setTimeout(() => {
            // Update title
            if (title) {
              title.textContent = data.data.name;
            }
            
            // Update background image and store it as data attribute to prevent parallax from overwriting
            if (data.data.image && bgElement) {
              const imageUrl = `url(${data.data.image})`;
              bgElement.style.backgroundImage = imageUrl;
              bgElement.setAttribute('data-bg-image', imageUrl);
            }
            
            // Fade back in
            setTimeout(() => {
              if (title) title.classList.remove('is-changing');
              if (bgElement) bgElement.classList.remove('is-changing');
            }, 50);
          }, 300); // Match the CSS transition duration
        }
      }
    })
    .catch(error => {
      console.error('Error updating header:', error);
    });
  }
  
  // Handle search input with debounce
  searchInput.addEventListener('input', function() {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => {
      currentPage = 1;
      hasMore = true;
      filterEvents(true); // true = replace content
    }, 300); // Wait 300ms after user stops typing
  });
  
  // Handle browser back/forward buttons
  window.addEventListener('popstate', function() {
    currentCategory = getInitialCategory();
    
    // Update active tab
    filterTabs.forEach(tab => {
      if (tab.dataset.category === currentCategory) {
        tab.classList.add('active');
      } else {
        tab.classList.remove('active');
      }
    });
    
    // Reload page to update header
    location.reload();
  });
  
  // AJAX filter function
  function filterEvents(replace = false) {
    if (isLoading || (!replace && !hasMore)) return;
    
    isLoading = true;
    const searchTerm = searchInput.value.trim();
    
    // Show loading indicator
    if (loadingIndicator) {
      loadingIndicator.style.display = 'block';
    }
    
    // Add loading state for replace
    if (replace) {
      gridContainer.style.opacity = '0.5';
    }
    
    // Make AJAX request
    fetch(ajaxurl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        action: 'filter_events',
        category: currentCategory,
        search: searchTerm,
        page: currentPage
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        if (replace) {
          // Replace grid content
          gridContainer.innerHTML = data.data.html;
        } else {
          // Append to grid content
          gridContainer.insertAdjacentHTML('beforeend', data.data.html);
        }
        
        // Update pagination state
        hasMore = data.data.has_more;
        currentPage++;
        
        // Remove loading state
        gridContainer.style.opacity = '1';
        if (loadingIndicator) {
          loadingIndicator.style.display = hasMore ? 'none' : 'none';
        }
        isLoading = false;
        
        console.log(`Loaded ${data.data.count} events (${data.data.total} total, has more: ${hasMore})`);
      }
    })
    .catch(error => {
      console.error('Error filtering events:', error);
      gridContainer.style.opacity = '1';
      if (loadingIndicator) {
        loadingIndicator.style.display = 'none';
      }
      isLoading = false;
    });
  }
  
  // Infinite scroll handler
  function handleScroll() {
    if (isLoading || !hasMore) return;
    
    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.documentElement.scrollHeight;
    const triggerPoint = pageHeight - 500; // Load when 500px from bottom
    
    if (scrollPosition >= triggerPoint) {
      filterEvents(false); // false = append content
    }
  }
  
  // Attach scroll listener
  window.addEventListener('scroll', handleScroll);
  
  // Throttle scroll events for better performance
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    if (scrollTimeout) return;
    scrollTimeout = setTimeout(() => {
      handleScroll();
      scrollTimeout = null;
    }, 100);
  });
});
